import { Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { OlapService } from '../../service/olap-service.service';
import * as moment from 'moment';

@Component({
  selector: 'app-dependent-form',
  templateUrl: './app-dependent-form.component.html',
})
export class AppDependentFormComponent implements OnChanges {

    @Input() numberOfDependents: number = 0;
    @Input() dependents: any[] = [];

    constructor(private olapService: OlapService) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.numberOfDependents) {
            this.updateDependents();
        }
    }

    updateDependents() {
        if (this.numberOfDependents < this.dependents.length) {
            this.dependents.splice(this.numberOfDependents);
        } else {
            const diff = this.numberOfDependents - this.dependents.length;
            for (let i = 0; i < diff; i++) {
                this.dependents.push({ 
                    dependent_name: '', 
                    dependent_bday: '', 
                    is_valid_dependent_name: true, // true at first (no red highlight on input)
                    is_valid_dependent_bday: true
                });
            }
        }
        this.olapService.updateDependents(this.dependents);
    }

    onNameChange(index: number, newName: string) {
        this.dependents[index].dependent_name = newName.slice(0, 100);

        if ( newName.slice(0, 100).length > 0 ) 
            this.dependents[index].is_valid_dependent_name = true;
        else this.dependents[index].is_valid_dependent_name = false;

        this.updateDependents(); // Update and emit changes
    }
  
    onBirthdayChange(index: number, newBirthday: Date) {
        const momentBirthday = moment(newBirthday).format('MM/DD/YYYY')
        this.dependents[index].dependent_bday = newBirthday;
        if ( this.isValidDate(momentBirthday) ) { 
            this.dependents[index].is_valid_dependent_bday = true;
            this.updateDependents(); // Update and emit changes
        }
        else {
            this.dependents[index].is_valid_dependent_bday = false;
        }
    }

    isValidDate(dateString: string): boolean { // same as isCorrectDateFormat in sss-apply.component.ts
        console.log('checking if given date string is valid: ' );
        console.log(dateString)
        const datePattern = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
        return datePattern.test(dateString);
    }
}



// WEBPACK FOOTER //
// /opt/sss_web/sss_web/src/app/components/app-dependent-form/app-dependent-form.component.ts